import { useLocale } from '../i18n/LocaleProvider'
import CorporatePageLayout from '../components/CorporatePageLayout'
import { usePageTitle } from '../hooks/usePageTitle'
import './PublicInfoPage.css'

const COLUMNS = [
  {
    language: 'ja',
    title: '電子公告',
    kicker: '電子公告一覧',
    message: '現在、掲載中の電子公告はありません。',
    detail: '電子公告を行う場合は、このページに公告内容および関連資料を掲載します。',
  },
  {
    language: 'en',
    title: 'Electronic Public Notices',
    kicker: 'Public notice archive',
    message: 'There are no electronic public notices currently posted.',
    detail: 'When Bybeit issues an electronic public notice, the notice and any related materials will be published on this page.',
  },
] as const

export default function AnnouncementsPage() {
  const { locale, t } = useLocale()
  usePageTitle('Electronic Public Notices')

  return (
    <CorporatePageLayout
      title={t("Announcements")}
      compactTitleOnMobile
      japaneseSubtitle={(
        <>
          バイバイト株式会社が行う電子公告を<br />
          こちらからご確認いただけます。
        </>
      )}
      englishSubtitle={(
        <>
          View electronic public notices issued by<br />
          Bybeit, Inc. here.
        </>
      )}
    >
      <main className="ip-main container">
        <div className="ip-language-grid">
          {COLUMNS.filter(column => column.language === locale).map((column) => (
            <div
              className={`ip-language-column ip-language-column--${column.language}`}
              key={column.language}
              lang={column.language}
            >
              <section className="ip-section">
                <h2 className="ip-section-title">{column.title}</h2>
                <div className="ip-message">
                  <span className="ip-message-kicker">{column.kicker}</span>
                  <p className="ip-message-title">{column.message}</p>
                  <p className="ip-message-copy">{column.detail}</p>
                </div>
              </section>
            </div>
          ))}
        </div>
      </main>
    </CorporatePageLayout>
  )
}
